import { FC, useEffect, useState } from "react";
import { View, Text } from "react-native";
import axios from "axios";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { Router, useRouter } from "expo-router";
import { IUsersInfo } from "@/_store/auth/contracts";
import { setAuthToken } from "@/_reducers/accounts.reducer";
import { useAppDispatch } from "@/_hooks";
import CustomButton from "@/app/components/CustomButton";
import CustomRadioButton from "@/app/components/CustomRadioButton";
import Container from "@/app/components/Container";
import { useLazyGetCurrentUserQuery } from "@/_store/currentUser/currentUser.slice";

interface IChooseAccountProps {
  accounts: IUsersInfo[];
}

const ChooseAccount: FC<IChooseAccountProps> = ({ accounts }) => {
  const [selected, setSelected] = useState<IUsersInfo | null>(null);
  const dispatch = useAppDispatch();
  const router: Router = useRouter();

  const [fetchUser, { data: user, error, isFetching }] = useLazyGetCurrentUserQuery();

  const handleLogin = async (): Promise<void> => {
    if (!selected?.token) return;

    await AsyncStorage.setItem("token",  selected.token);
    axios.defaults.headers.common.Authorization = `Bearer ${selected.token}`;
    dispatch(setAuthToken(selected.token));
    fetchUser();
  };

  useEffect(() => {
    if (isFetching) return;

    if (error) {
      console.error("Ошибка при получении пользовательского соглашения:", error);
      router.replace("/login");
      return;
    }

    if (user) {
      if (!user.accepted_personal_data) {
        router.replace("/user-agreement");
      } else {
        router.replace("/general");
      }
    }
  }, [user, isFetching, error, router]);

  const navigateToLoginPage = (): void => router.replace("/login");

  return (
    <Container>
      <View className="flex flex-col">
        <Text className="text-header mb-6">Выберите аккаунт</Text>
        <View className="mb-6">
          {accounts?.map((account: IUsersInfo, index: number) => (
            <CustomRadioButton
              key={index}
              label={account?.user?.company_name || "Наименование\u00a0компании\u00a0не\u00a0указано"}
              value={account}
              selectedValue={selected}
              onSelect={setSelected}
            />
          ))}
        </View>
        <CustomButton
          title="Войти"
          className="mb-6"
          onPress={handleLogin}
          disabled={!selected}
        />
        <CustomButton
          title="Назад к авторизации"
          type="text"
          onPress={navigateToLoginPage}
        />
      </View>
    </Container>
  );
};

export default ChooseAccount;
